'use strict';

define(
	'BetSlipAccountInfoDir',[],function () {
		function BetSlipAccountInfoDir() {
			return {
				restrict: 'E',
				templateUrl: 'js/modules/BetSlipWindow/templates/betslip-account-info.html',
				controller: 'BetSlipAccountInfoCtrl',
				scope: true
			};
		}
		return BetSlipAccountInfoDir;
	}
);

